<template>
  <div class="qr-code-container">
    <div class="qr-code-wrapper">
      <QRCodeVue
      :value="currentUrl"
      :size="size"
      :level="level"
      :background="background"
      :foreground="foreground"
    />
    </div>

    <div class="qr-code-text">{{ multiLan('scan_qr_code') }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import QRCodeVue from 'qrcode.vue'
import { multiLan } from '../assets/lan'

const currentUrl = ref('')
const size = 200
const level = 'H'
const background = '#ffffff'
const foreground = '#000000'

onMounted(() => {
  currentUrl.value = window.location.href
})
</script>

<style scoped>
.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  min-width: 200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.qr-code-wrapper {
  width: 240px;
  height:240px;
  background-image: url('../assets/images/code_bg.png');
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-code-text {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}
</style>
